// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"d53cea19","1008":"334f6ff3","1578":"e038f9b8","2686":"e038f9b8","3683":"e038f9b8"}[chunkId] + ".chunk.css";
};